// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"79fa432e","418":"8d6b8ac5","593":"bfd73e44","856":"b5cf4b8e","961":"971eddaf"}[chunkId] + ".chunk.css";
};